var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6013 4.25484L16.7686 6.42107L14.6013 4.25484ZM15.995 2.34647L10.1348 8.20665C9.832 8.50902 9.62549 8.89427 9.5413 9.31382L9 12.0234L11.7096 11.4811C12.1291 11.3972 12.5139 11.1915 12.8167 10.8886L18.6769 5.02842C18.853 4.85232 18.9927 4.64326 19.088 4.41318C19.1833 4.18309 19.2324 3.93649 19.2324 3.68744C19.2324 3.4384 19.1833 3.1918 19.088 2.96171C18.9927 2.73163 18.853 2.52257 18.6769 2.34647C18.5008 2.17037 18.2918 2.03068 18.0617 1.93537C17.8316 1.84007 17.585 1.79102 17.336 1.79102C17.0869 1.79102 16.8403 1.84007 16.6102 1.93537C16.3801 2.03068 16.1711 2.17037 15.995 2.34647V2.34647Z",
    stroke: "#F19425",
    strokeWidth: 2.04651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1862 14.0695V17.1392C17.1862 17.682 16.9706 18.2025 16.5868 18.5863C16.203 18.9701 15.6825 19.1858 15.1397 19.1858H3.88391C3.34115 19.1858 2.82061 18.9701 2.43681 18.5863C2.05302 18.2025 1.8374 17.682 1.8374 17.1392V5.88343C1.8374 5.34066 2.05302 4.82012 2.43681 4.43632C2.82061 4.05253 3.34115 3.83691 3.88391 3.83691H6.95368",
    stroke: "#F19425",
    strokeWidth: 2.04651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineEdit);
export default __webpack_public_path__ + "static/media/lineEdit.3d4d6ab0.svg";
export { ForwardRef as ReactComponent };